module.exports = __webpack_public_path__ + "static/media/757MeldrumStNW_2018-06-18_119.2b3fee02.jpg";